import * as Sentry from "@sentry/nextjs";

const sentryClientInit = (dsn: string): void =>
  Sentry.init({
    dsn: dsn,
    tracesSampleRate: 0.7,
  });

export default sentryClientInit;
